import React, { useState, useEffect } from 'react';
import TopBar from './TopBar';
import { ELEMENTS } from '../utils/constants';

function EditUtopia({ state, setState, setRoute }) {
  const [tempUtopia, setTempUtopia] = useState(state.utopia);
  const [hasChanges, setHasChanges] = useState(false);

  // Check if there are unsaved changes
  useEffect(() => {
    const hasUnsavedChanges = Object.keys(tempUtopia).some(key => 
      tempUtopia[key] !== state.utopia[key]
    );
    setHasChanges(hasUnsavedChanges);
  }, [tempUtopia, state.utopia]);

  const saveUtopiaField = (key, value) => { 
    setTempUtopia((t) => ({ ...t, [key]: value })); 
  };

  const handleSave = () => {
    setState((s) => ({ ...s, utopia: tempUtopia }));
    setRoute("settings");
  };

  const handleCancel = () => {
    setTempUtopia(state.utopia); // Reset to original values
    setRoute("settings");
  };

  return (
    <div className="p-4">
      <TopBar title="Edit Utopia Settings" onBack={handleCancel} />
      <div className="mt-3">
        <div className="mb-4">
          <p className="text-sm text-gray-600 dark:text-dark-textSecondary">
            Edit your utopia descriptions for each element. These serve as reminders of your ideal state.
          </p>
        </div>
        
        <div className="space-y-4">
          {ELEMENTS.map((element, index) => (
            <div key={element.key} className="p-4 rounded-lg border dark:border-dark-border bg-white dark:bg-dark-surface">
              <div className="flex items-center gap-2 mb-3">
                <div className="text-2xl">{element.emoji}</div>
                <div>
                  <div className="text-lg font-medium dark:text-dark-text">{element.label}</div>
                  <div className="text-sm text-gray-600 dark:text-dark-textSecondary">{element.hint}</div>
                </div>
              </div>
              <textarea
                value={tempUtopia[element.key] || ''}
                onChange={(e) => saveUtopiaField(element.key, e.target.value)}
                className="w-full rounded-md border dark:border-dark-border p-3 text-sm bg-white dark:bg-dark-bg text-gray-900 dark:text-dark-text min-h-[100px]"
                placeholder={`I imagine my ${element.label.toLowerCase()}...`}
              />
              <div className="text-xs text-gray-500 dark:text-dark-muted mt-1">
                {(tempUtopia[element.key] || '').length} characters
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 flex gap-3">
          <button 
            onClick={handleCancel}
            className="flex-1 py-3 rounded-md border dark:border-dark-border dark:bg-dark-surface dark:text-dark-text hover:bg-gray-50 dark:hover:bg-dark-surfaceHover"
          >
            Cancel
          </button>
          <button 
            onClick={handleSave}
            disabled={!hasChanges}
            className={`flex-1 py-3 rounded-md font-medium ${
              hasChanges 
                ? 'bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 dark:hover:bg-blue-600' 
                : 'bg-gray-300 dark:bg-dark-border text-gray-500 dark:text-dark-muted cursor-not-allowed'
            }`}
          >
            {hasChanges ? 'Save Changes' : 'No Changes'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditUtopia;
